import { render, staticRenderFns } from "./PMSMain.vue?vue&type=template&id=04ba07ab"
import script from "./PMSMain.vue?vue&type=script&lang=js"
export * from "./PMSMain.vue?vue&type=script&lang=js"
import style0 from "./PMSMain.vue?vue&type=style&index=0&id=04ba07ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports